<template>
  <BaseListPage
      :name="name"
      :base-query="baseQuery"
      :store-path="storePath"
      :response-path="responsePath"
      :save-key="saveKey"
      :table-set-list="tableSetList"
      :table-data-list="sortedList"
      title="ポイント一覧"
      title-class="point-header"
      icon="customer"
      table-class="point-table-list row-clickable-table"
      @row-click="onRowClick" />
</template>

<script>
import _ from 'lodash'

import { mapState, mapGetters } from 'vuex'
import * as query from '@/queries/point'
import x from '@/components/mixins/mixin'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/organisms/BaseListPage'

export default {
  name: 'PointList',
  components: {
    BaseListPage
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState({
      tableSetList: (state) => state.Point.tableSetList
    }),
    ...mapGetters({
      getSortedList: 'sortedList'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'pointList'
    },
    storePath () {
      return 'Point'
    },
    saveKey () {
      return 'pointCondition'
    },
    responsePath () {
      return 'data.points.edges'
    },
    linkKey () {
      return 'node.customer.uuid'
    },
    returnPath () {
      return '/point'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_POINT_LIST
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        { type: 'String', label: '顧客ID', path: 'node.customer.id', sortable: 'custom' },
        {
          type: 'String', label: '顧客番号', path: 'node.customerNo',
          elementType: ELEMENT_TYPE.LINK, linkKey: 'node.customerNo', sortable: 'custom'
        },
        { type: 'Date', label: '登録日時', path: 'node.createdAt', sortable: 'custom' },
        {
          type: 'String', label: 'ポイント区分', path: 'node.pointType',
          codeName: 'd_point.point_type', sortable: 'custom'
        },
        {
          type: 'Number', label: '期間限定フラグ', path: 'node.isLimited',
          elementType: ELEMENT_TYPE.CHECK_BOX, class: 'center', sortable: 'custom'
        },
        { type: 'Number', label: 'ポイント数', path: 'node.point', sortable: 'custom' },
        { type: 'Number', label: '残ポイント数', path: 'node.point', sortable: 'custom' },
        { type: 'Date', label: '有効期限', path: 'node.expires', sortable: 'custom' },
        {
          type: 'Number', label: '理由コード', path: 'node.reasonCode',
          codeName: 'd_point.reason_code', sortable: 'custom'
        },
        { type: 'Number', label: '追加情報', path: 'node.note', sortable: 'custom' },
        { type: 'Number', label: '内部メモ', path: 'node.memo', sortable: 'custom' }
      ]
    }
  },
  created () {
    this.$store.dispatch({
      type: 'set',
      states: {
        'Point/tableSetList': this._tableSetList
      }
    })
  },
  methods: {
    onRowClick (row, column, event) {
      const id = _.get(row, this.linkKey)
      const index = this.$_mixin_findIndex(this.sortedList, { [this.linkKey]: id })
      this.$_mixin_onLinkClick(index, this.storePath)
      this.$router.push({ path: `/customer/${id}` })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/customer/PointListTop.vue